import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { CustomerDetailBanner } from "../../../blocks/heigh-educate-banner";
import { useTranslation } from "react-i18next";
import { CommonPageLink } from "../../../blocks/common-page-link";
import { CustomerDetailIntro } from "../../../blocks/customer-detail-intro";
import { Footer } from "../../../components/FooterV2";
import { CustomerDetailChallenge } from "../../../blocks/customer-detail-challenge";
import { CustomerDetailIdea } from "../../../blocks/customer-detail-idea";
import { HomeTryOn } from "../../../blocks/home-try-on";
import { Helmet } from "react-helmet";

export const HuaxiPage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const challenges = [
    {
      title: t("customer.huaxi.challenge.item1.title"),
      description: t("customer.huaxi.challenge.item1.description"),
    },
    {
      title: t("customer.huaxi.challenge.item2.title"),
      description: t("customer.huaxi.challenge.item2.description"),
    },
    {
      title: t("customer.huaxi.challenge.item3.title"),
      description: t("customer.huaxi.challenge.item3.description"),
    },
  ];
  const ideas = [
    {
      title: t("customer.huaxi.ideas.item1.title"),
      descript: t("customer.huaxi.ideas.item1.subtitle"),
      icon: "authing-like",
    },
    {
      title: t("customer.huaxi.ideas.item2.title"),
      descript: t("customer.huaxi.ideas.item2.subtitle"),
      icon: "authing-insurance",
    },
    {
      title: t("customer.huaxi.ideas.item3.title"),
      descript: t("customer.huaxi.ideas.item3.subtitle"),
      icon: "authing-idcard",
    },
  ];
  return (
    <div className="huaxi-page">
      <Helmet>
        <title>
          华西医院SSO单点登录案例_华西医院统一身份认证客户案例-Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode="dark" defaltNav={true} />
      <CustomerDetailBanner
        title={t("customer.huaxi.banner.title")}
        addtionTitle={t("customer.huaxi.banner.addtionTitle")}
        subtitle={t("customer.huaxi.banner.subtitle")}
        theme="#BF9D5B"
        alt="华西医院SSO单点登录案例"
        imgUrl={
          "//files.authing.co/authing-website/customer-detail-banner-hospital-en.png"
        }
      />
      <CustomerDetailIntro
        imgUrl={t("customer.huaxi.intro.imgUrl")}
        alt="医疗行业单点登录"
        content={
          <>
            <p>{t("customer.huaxi.intro.descript1")}</p>
            <p>{t("customer.huaxi.intro.descript2")}</p>
          </>
        }
      />
      <CustomerDetailChallenge challenges={challenges} theme={"#BF9D5B"} />
      <CustomerDetailIdea ideas={ideas} theme={"#BF9D5B"} />
      <CommonPageLink pagesLink={pagesLink} theme={"#BF9D5B"} />
      <HomeTryOn hasBg />
      <Footer />
    </div>
  );
};
